import { useTranslate } from 'hooks/useTranslate';
import IconInfo from 'modules/_shared/components/Icon/IconTooltip';
import { FC } from 'react';

type AiAgentTitleProps = {
  hasStartedChat: boolean;
  subTitle?: string;
};

const AiAgentTitle: FC<AiAgentTitleProps> = ({ hasStartedChat, subTitle }) => {
  const { t } = useTranslate();

  return (
    <div className={`main-title ${hasStartedChat ? 'main-title-compact' : ''}`}>
      <h1 className="mb-0">{t('AI_HeaderTitle')}</h1>

      {subTitle ? (
        <IconInfo
          id="ai-header-scope-tooltip"
          tooltip={subTitle}
          place="bottom"
          className="d-none d-md-inline-block"
        />
      ) : null}
    </div>
  );
};

export default AiAgentTitle;
